module.exports = __webpack_public_path__ + "static/img/14085A_X_07_20170525_fit.898fcc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/14085A_X_07_20170525_fit.png
// module id = Mtax
// module chunks = 0